import z from "zod";
import { LimitEvaluationEnum } from "../domain/entities/LimitControlEntity";
import { LimitControlApiRepository } from "./LimitControlApiRepository";

export const columns = [
    { header: "Tipo de Límite", accessor: "limitType.name" },
    { header: "Evaluación", accessor: "limitEvaluation" },
    {
        header: "Porcentaje",
        accessor: "percentage",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "percent",
                minimumFractionDigits: 2,
            }).format(value / 100),
    },
    { header: "Sublímite", accessor: "subLimit.name" },
    { header: "Denominador", accessor: "denominator.name" },
    { header: "Portafolio", accessor: "portfolio.name" },
    {
        header: "Creado",
        accessor: "createdAt",
        render: (value: Date) => value.toDateString(),
    },
];

export const limitEvaluationOptions = [
    { label: LimitEvaluationEnum[LimitEvaluationEnum.MAX], value: LimitEvaluationEnum.MAX.toString() },
    { label: LimitEvaluationEnum[LimitEvaluationEnum.MIN], value: LimitEvaluationEnum.MIN.toString() },
];

export const schema = z.object({
    id: z.string().optional(),
    limitType: z.string().min(1, "El tipo de límite es obligatorio"),
    subLimit: z.string().min(1, "El subtipo de límite es obligatorio"),
    limitEvaluation: z.string().min(1, "La evaluación es obligatoria"),
    percentage: z.number({ invalid_type_error: "El porcentaje debe ser un número" })
        .min(1, "Debe ser mayor a 0")
        .max(100, "Debe ser menor o igual a 100"),
    portfolio: z.string().min(1, "El portafolio es obligatorio"),
    denominator: z.string().min(1, "El denominador es obligatorio"),
});

export type LimitFormData = z.infer<typeof schema>;

export const limitRepository = new LimitControlApiRepository();

export const limitKeys = {
    all: ['limits'] as const,
    details: (id: string) => [...limitKeys.all, id] as const,
    allTypes: ['limitTypes'] as const,
    allSubTypesByType: ['sublimitTypes'] as const,
    allPortfolio: ['portfolio'] as const,
    allDenominator: ['denominator'] as const,
};